import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface RemoveFromBlacklistResponse extends APIResponse
{
}

export class RemoveFromBlacklistResponseDtoImpl extends APIResponseDtoImpl implements RemoveFromBlacklistResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/removefromblacklist/removefromblacklistresponse.tsx